const ENV = {
  API_BASE_URL: process.env.REACT_APP_API_BASE,
  USER_SERVICE_URL: process.env.REACT_APP_USER_SERVICE_URL,
  MESSAGING_SERVICE_URL: process.env.REACT_APP_MESSAGING_SERVICE_URL,
  COMMAN_SERVICES_URL: process.env.REACT_APP_COMMAN_SERVICES_URL,
  COMPANY_SERVICES_URL: process.env.REACT_APP_COMPANY_SERVICES_URL,
  CANDIDATE_SERVICES_URL: process.env.REACT_APP_CANDIDATE_SERVICES_URL,
  BILLING_SERVICE_URL: process.env.REACT_APP_BILLING_SERVICE_URL,
  RAZORPAY_KEY: process.env.REACT_APP_RAZORPAY_KEY,
  DOCUMENT_UPLOAD_URL: `${process.env.REACT_APP_API_BASE}/gateway-service/document-service/upload/Document`,
};

export default ENV;
